export const ApplicationModuleFeatureEnum = {
    INTEGRATIONS_CREATE: '67f7fcf31a1b95782639a921',
    INTEGRATIONS_EDIT: '67f7fcf31a1b95782639a922',
    INTEGRATIONS_DELETE: '67f7fcf31a1b95782639a923',
    INTEGRATIONS_VIEW: '67f7fcf31a1b95782639a924',
    INTEGRATIONS_RUN: '67f7fcf31a1b95782639a925',
    DATA_TYPES_CREATE: '67f7fcf31a1b95782639a926',
    DATA_TYPES_EDIT: '67f7fcf31a1b95782639a927',
    DATA_TYPES_DELETE: '67f7fcf31a1b95782639a928',
    DATA_TYPES_VIEW: '67f7fcf31a1b95782639a929',
    MAPPINGS_CREATE: '67f7fcf31a1b95782639a930',
    MAPPINGS_EDIT: '67f7fcf31a1b95782639a931',
    MAPPINGS_DELETE: '67f7fcf31a1b95782639a932',
    MAPPINGS_VIEW: '67f7fcf31a1b95782639a933',
    MAPPINGS_RUN: '67f7fcf31a1b95782639a934',
    VPN_MANAGEMENT_CREATE: '67f7fcf31a1b95782639a935',
    VPN_MANAGEMENT_VIEW: '67f7fcf31a1b95782639a936',
    IFS_REQUEST_ACCESS: '67f7fcf31a1b95782639a937',
    IFS_EDIT: '67f7fcf31a1b95782639a938',
    IFS_VIEW: '67f7fcf31a1b95782639a939',
    MY_APP_CREATE: '67f7fcf31a1b95782639a940',
    MY_APP_EDIT: '67f7fcf31a1b95782639a941',
    MY_APP_DELETE: '67f7fcf31a1b95782639a942',
    MY_APP_VIEW: '67f7fcf31a1b95782639a943',
    APP_INSTANCE_CREATE: '67f7fcf31a1b95782639a944',
    APP_INSTANCE_EDIT: '67f7fcf31a1b95782639a945',
    APP_INSTANCE_DELETE: '67f7fcf31a1b95782639a946',
    APP_INSTANCE_VIEW: '67f7fcf31a1b95782639a947',
    COMPARISONS_CREATE: '67f7fcf31a1b95782639a948',
    COMPARISONS_EDIT: '67f7fcf31a1b95782639a949',
    COMPARISONS_DELETE: '67f7fcf31a1b95782639a950',
    COMPARISONS_VIEW: '67f7fcf31a1b95782639a951',
    COMPARISONS_RUN: '67f7fcf31a1b95782639a952',
    LOGGING_VIEW_PLATFORM: '67f7fcf31a1b95782639a953',
    LOGGING_VIEW_APP_REQUEST: '67f7fcf31a1b95782639a954',
    LOGGING_VIEW_COMPARISON: '67f7fcf31a1b95782639a955',
    LOGGING_VIEW_MAPPINGS: '67f7fcf31a1b95782639a956',
    LOGGING_VIEW_INTEGRATION: '67f7fcf31a1b95782639a957',
    USER_MANAGEMENT_CREATE: '67f7fcf31a1b95782639a958',
    USER_MANAGEMENT_EDIT: '67f7fcf31a1b95782639a959',
    USER_MANAGEMENT_DELETE: '67f7fcf31a1b95782639a960',
    USER_MANAGEMENT_EDIT_ROLE: '67f7fcf31a1b95782639a961', // TODO not used yet
    USER_MANAGEMENT_VIEW: '67f7fcf31a1b95782639a962',
    USER_MANAGEMENT_RESET_OTHER_USER_PASSWORD: '67f7fcf31a1b95782639a963',
    USER_MANAGEMENT_RESET_OWN_PASSWORD: '67f7fcf31a1b95782639a964',
    ORGANIZATION_MANAGEMENT_EDIT: '67f7fcf31a1b95782639a965',
    ORGANIZATION_MANAGEMENT_VIEW: '67f7fcf31a1b95782639a966',
    CROSSWALKS_CREATE: '67f7fcf31a1b95782639a970',
    CROSSWALKS_EDIT: '67f7fcf31a1b95782639a971',
    CROSSWALKS_DELETE: '67f7fcf31a1b95782639a972',
    CROSSWALKS_VIEW: '67f7fcf31a1b95782639a973',
    CROSSWALKS_RUN: '67f7fcf31a1b95782639a974',
    VPN_MANAGEMENT_EDIT: '67f7fcf31a1b95782639a975',
    VPN_MANAGEMENT_DELETE: '67f7fcf31a1b95782639a976',
    INTERFACE_SERVER_CREATE: '67f7fcf31a1b95782639a977',
    INTERFACE_SERVER_EDIT: '67f7fcf31a1b95782639a978',
    INTERFACE_SERVER_DELETE: '67f7fcf31a1b95782639a979',
    INTERFACE_SERVER_VIEW: '67f7fcf31a1b95782639a980',
    INTERFACE_SERVER_SEND_MESSAGE: '67f7fcf31a1b95782639a981',
    INTERFACE_SERVER_VIEW_MESSAGES: '67f7fcf31a1b95782639a982',
    CUSTOM_SCRIPTS_VIEW: '67f7fcf31a1b95782639a990',
    CUSTOM_SCRIPTS_RUN: '67f7fcf31a1b95782639a991',
    ACCESS_ADMIN_SITE: '6838c1972fff5e2e18d708d8',
};
